<!-- Base functionality for this component was pulled from form-repeating. Reference that when new functionality needs to be added -->
<div class="custom-tabs mt-3">
  <div class="source-disclaimer">
    Enter data for each source below.
    {{ `Total of ${field.fieldGroup.length} source(s).` }}
  </div>
  <mat-tab-group
    class="mb-3 form-tab-repeat-group"
    mat-stretch-tabs="true"
    disablePagination="false"
    [selectedIndex]="selectedIndex"
    (selectedIndexChange)="handleKeyUpAdd($event)"
  >
    @for (subField of field.fieldGroup; track subField.id; let i = $index) {
      <mat-tab>
        <ng-template mat-tab-label>
          @if (subField.formControl.status === 'INVALID') {
            <mat-icon class="error-icon ms-0 me-1">error</mat-icon>
          }

          <span
            class="tab-label {{
              subField.formControl.status === 'INVALID' ? 'warning' : ''
            }}"
            [matTooltip]="getTooltip(subField, field, i)"
          >
            @if (
              field.fieldArray.props.headerName &&
              subField.model[field.fieldArray.props.headerName] &&
              !field.fieldArray.props.headerConditionalVar
            ) {
              {{ subField.model[field.fieldArray.props.headerName] }}
            } @else if (
              field.fieldArray.props.headerName &&
              subField.model[field.fieldArray.props.headerName] &&
              field.fieldArray.props.headerConditionalVar
            ) {
              {{
                subField.model[field.fieldArray.props.headerConditionalVar] ===
                field.fieldArray.props.headerConditionalVal
                  ? subField.model[field.fieldArray.props.headerAlt]
                  : subField.model[field.fieldArray.props.headerName]
              }}
            } @else {
              Source {{ i + 1 }}
            }
          </span>

          @if (field.fieldGroup.length < 5) {
            <span class="tab-amount ms-1">
              @if (
                field.fieldArray.props.headerAmount &&
                subField.model[field.fieldArray.props.headerAmount] &&
                !subField.model[field.fieldArray.props.headerAmount].includes(
                  '$'
                )
              ) {
                ({{
                  subField.model[field.fieldArray.props.headerAmount]
                    | currency: 'USD' : 'symbol-narrow' : '1.0-0'
                }})
              } @else if (
                field.fieldArray.props.headerAmount &&
                subField.model[field.fieldArray.props.headerAmount] &&
                subField.model[field.fieldArray.props.headerAmount].includes(
                  '$'
                )
              ) {
                ({{ subField.model[field.fieldArray.props.headerAmount] }})
              } @else {
                ($0)
              }
            </span>
          }

          @if (showDelete(subField)) {
            <button
              type="button"
              class="remove-tab-button ms-3"
              (click)="exitButton($event, i)"
            >
              <mat-icon class="me-0">close</mat-icon>
            </button>
          }
        </ng-template>
        <ng-template matTabContent>
          <div class="formly-plan-container mb-3">
            <formly-group
              [field]="subField"
              [class]="'w-100 row formly-form-container'"
            />
            @if (showDelete(subField)) {
              <div class="button-container remove clearfix w-100 mb-3">
                <button
                  mat-button
                  class="btn btn-danger w-100"
                  color="warn"
                  type="button"
                  [disabled]="subField.props.disableCheck"
                  (click)="remove(i)"
                  (keydown.enter)="$event.preventDefault()"
                >
                  <mat-icon class="me-2">cancel</mat-icon>Remove
                </button>
              </div>
            }
            @if (!disableAdd && !hideAddRemove) {
              <div class="button-container remove clearfix w-100 mb-2">
                <button
                  mat-raised-button
                  class="btn btn-primary w-100"
                  color="primary"
                  type="button"
                  (click)="add(true)"
                >
                  <mat-icon class="me-2">add_circle</mat-icon>Add
                  {{ getAddBtnLabel() }}
                </button>
              </div>
            }
          </div>
        </ng-template>
      </mat-tab>
    }
    @if (!hideAddRemove) {
      <mat-tab [labelClass]="'add-tab'">
        <ng-template mat-tab-label>
          @if (loading) {
            <mat-spinner diameter="24" />
          } @else {
            <mat-icon class="me-2">add_circle</mat-icon>Add
          }
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</div>
